import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';
import Deflector from './Deflector';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function ShotMissedEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const period = periods[event.period].name;
  const shooter = players[event.player];
  const deflector = event.deflect && players[event.deflect.player];

  const team = teams[shooter.team].id;

  return (
    <Base
      time={event.second}
      period={period}
      team={team}
      type={`${deflector ? 'Deflected ' : ''}Shot Missed`}
    >
      <Typography variant="body2">
        Shot by{' '}
        <span className={classes.bold}>{shooter.name}</span>
        <Deflector deflector={deflector} />
        {' '}has missed the net
      </Typography>
    </Base>
  )
}

export default ShotMissedEvent;
